import styled from '@emotion/styled';

import { ExternalLink as ExternalLinkBase } from '../ExternalLink/ExternalLink';

export const ExternalLink = styled(ExternalLinkBase)`
  margin-right: 0.5em;
`;



// WEBPACK FOOTER //
// ./src/components/LE/ExternalLink.js